<template>
    <div class="content-wrap sun home">
        <div class="dead-line" v-if="sunScoreDeadLine">
            活动已于{{ sunScoreDeadLine }}截止，积分将不再累加
        </div>
        <!-- <img
            src="https://guokrapp-static.guokr.com/Fmlm9sKOALJyfwa5uQkhdnCcx8b2"
            alt=""
            class="bg-bottom"
        /> -->
        <div class="home-content">
            <div class="bg-banner" />
            <div class="q-buttons">
                <div class="main-button" @click="() => handleRouter('daily')">
                    每日答题
                    <span>{{
                        `${user.daily_quiz_times}/${maxDailyTime}`
                    }}</span>
                </div>
                <div
                    class="main-button"
                    @click="() => handleRouter('challenge')"
                >
                    进阶挑战
                    <span>{{
                        `${user.challenge_quiz_times}/${maxChallengeTime}`
                    }}</span>
                </div>
            </div>
            <div class="t-buttons">
                <div class="main-button" @click="() => handleRouter('top')">
                    排行榜
                </div>

                <div class="main-button" @click="() => handleRouter('articleList', false)">
                    学习园地
                </div>
            </div>
            <div class="o-buttons">
                <div
                    class="main-button"
                    @click="() => handleRouter('activity', false)"
                >
                    活动说明
                </div>
                <div class="main-button" @click="() => handleRouter('me')">
                    个人中心
                </div>
            </div>
            <span
                class="test"
                @click="
                    () =>
                        handleRouter(
                            'http://pro.bkweek.com/gongminsuzhi/Main',
                            false
                        )
                "
                >北京市公民科学素质大赛>>></span
            >
            <div class="info">
                <p>主办：北京市朝阳区新时代文明实践中心办公室</p>
                <p>北京市朝阳区科学技术协会</p>
                <!-- <p>承办：北京果壳互动科技传媒有限公司</p> -->
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
import { userApi } from "@/apis";
import { DateFormat } from "@/utils/func";

const BUTTON_ROUTE_MAP = {
    daily: "/quiz/rules/daily",
    challenge: "/quiz/rules/challenge",
    top: "/quiz/top",
    activity: "/quiz/rules/activity",
    me: "/quiz/me",
    articleList: "/quiz/articleList",
    test: "https://wj.qq.com/s2/6504536/25ef/",
};

export default {
    name: "home",
    data() {
        return {
            maxDailyTime: 0,
            maxChallengeTime: 0,
            user: {
                daily_quiz_times: 0,
                challenge_quiz_times: 0,
            },
            sunScoreDeadLine: ''
        };
    },
    methods: {
        async getEnvs() {
            const { sunScoreDeadLine } = await this.GLOBAL.getConfig(
                "sunScoreDeadLine"
            );
            this.sunScoreDeadLine =
                sunScoreDeadLine &&
                new Date().getTime() > new Date(sunScoreDeadLine).getTime()
                    ? DateFormat(sunScoreDeadLine, "MM月dd日h点")
                    : "";
        },
        async handleRouter(routeName, needAuth = true) {
            try {
                needAuth && (await this.$auth.check({ closable: true }));
                // 需要检测次数
                if (routeName === "daily") {
                    await this.getInfo();
                    if (this.user.daily_quiz_times >= this.maxDailyTime)
                        return Toast.fail(
                            `今日答题次数用完啦，明天记得回来看看\n\n还可以去“北京市公民科学素质大赛”答题哦`
                        );
                } else if (routeName === "challenge") {
                    await this.getInfo();
                    if (this.user.challenge_quiz_times >= this.maxChallengeTime)
                        return Toast.fail(
                            `今日挑战次数用完啦，明天记得回来看看\n\n还可以去“北京市公民科学素质大赛”答题哦`
                        );
                }
                const route = BUTTON_ROUTE_MAP[routeName] || routeName;
                this.location.push(route);
            } catch {
                console.log("cancel");
            }
        },
        async getInfo() {
            const logined = await this.$auth.check({ showModal: false });
            if (logined) {
                const { body } = await userApi.userUidGet({
                    params: {
                        uid: logined,
                    },
                });
                this.user = body;
            }
        },
        async getConfig() {
            Object.assign(
                this,
                await this.GLOBAL.getConfig("maxDailyTime,maxChallengeTime")
            );
        },
    },
    mounted() {
        this.getEnvs();
        this.getConfig();
        this.getInfo();
    },
};
</script>
<style lang="less">
.van-toast {
    width: auto;
    max-width: 75%;
    .van-toast__text {
        white-space: pre;
    }
}
</style>
<style lang="less" scoped>
.home {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    position: relative;
    color: #082754;
    font-size: 16px;
    line-height: 1em;
    background-image: url("https://guokrapp-static.guokr.com/Fmlm9sKOALJyfwa5uQkhdnCcx8b2"),
        linear-gradient(180deg, #3d4fe1 63%, #31a9e0 85%, #c48cbb 100%);
    .dead-line {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        padding: 0.2rem 0;
        background: #fd7202;
        color: #fff;
        text-align: center;
        font-size: 12px;
        z-index: 999;
    }
    img.bg-bottom {
        display: block;
        width: 100%;
        position: absolute;
        bottom: -1;
    }
    .bg-banner {
        flex: 1;
        display: block;
        margin: 0.5rem 0;
        width: 102%;
        background: url("https://guokrapp-static.guokr.com/FsKLxg5ndP5drOuWY2Vhmy9ZZY6k");
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
    .home-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        width: 100%;
        height: 100%;
        bottom: 0;
        .main-button {
            border-radius: 0.8rem;
            flex: 1;
            white-space: pre-line;
            border: none;
            font-size: inherit;
            text-align: center;
        }
        [class$="-buttons"] {
            margin: 0.25rem 0;
            width: 75%;
            display: flex;
            flex-direction: row;
        }
        .o-buttons,
        .t-buttons,
        .q-buttons {
            .main-button {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                background-color: #ffc700;
                font-weight: bold;
                height: 10.7vh;
                min-height: 5rem;
                line-height: 1.5;
                &:last-child {
                    background-color: #fc954c;
                    margin-left: 1.4rem;
                }
                span {
                    font-weight: normal;
                }
            }
        }
        .t-buttons {
            .main-button {
                background-color: #82b2ff;
                &:last-child {
                    background-color: #82b2ff;
                    margin-left: 1.4rem;
                }
            }
        }
        .o-buttons {
            .main-button {
                background-color: #fff;
                height: 6.3vh;
                min-height: 2rem;
                &:last-child {
                    background-color: #fff;
                    margin-left: 1.4rem;
                }
            }
        }
        .test {
            margin: 1rem 0;
            font-size: 18px;
            line-height: 1.5;
            color: #fff;
            text-shadow: rgba(44, 56, 148, 91) 0 0 8px;
        }
        .info {
            margin-bottom: 1rem;
            color: #fff;
            text-shadow: rgba(44, 56, 148, 91) 0 0 8px;
            p {
                font-weight: bolder;
                font-size: 10px;
                line-height: 1.5;
                text-align: center;
            }
        }
    }
}
</style>
